/**
 * User: Shad
 * Date: 9/4/13
 */
"use strict";

var SoaModel = require('bunsen/models/SoaModel');
var _ = require('underscore');
var root = typeof window === 'undefined' ? global : window;
var Adjustment;
root.bunsen = root.bunsen || {};

Adjustment = module.exports = root.bunsen.Adjustment = SoaModel.extend({
    constructor: function (data, options) {
        // These are down here because of circular dependencies
        var FlatAdjustment = require('bunsen/models/ecomm/FlatAdjustment');
        var PercentAdjustment = require('bunsen/models/ecomm/PercentAdjustment');
        // Adjustment has different relations based on the api type
        if (data.apiType === Adjustment.APITYPE_FLAT) {
            return new FlatAdjustment(data, options);
        }
        return new PercentAdjustment(data, options);
    }
});

_.extend(Adjustment, {
    REFERENCE_MERCHANDISE_TAX: 'MERCHANDISE_TAX',
    REFERENCE_SHIPPING_TAX: 'SHIPPING_TAX',
    REFERENCE_COMMISSION: 'COMMISSION',
    REFERENCE_PAYMENT_PROCESSING_FEE: 'PAYMENT_PROCESSING_FEE',
    REFERENCE_LISTING_CREDIT: 'LISTING_CREDIT',
    REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT: 'FIRSTDIBS_PROMOTION_OFFER_DISCOUNT',
    REFERENCE_COMPLIMENTARY_SHIPPING: 'COMPLIMENTARY_SHIPPING',
    REFERENCE_DEALER_CHARGE: 'DEALER_CHARGE',
    PROPERTY_RELEASE_DATE: 'releaseDate',
    PROPERTY_STARTING_DATE: 'creditStartingDate',
    PROPERTY_CREDIT_PERIOD: 'creditPeriod.timeUnit',
    PROPERTY_NUMBER_OF_UNITS: 'creditPeriod.numberOfUnits',
    PROPERTY_ELIGIBLE_CREDIT_PERIOD: 'eligibleCreditPeriod.numberOfUnits',
    APITYPE_PERCENT: 'percentAdjustmentRate',
    APITYPE_FLAT: 'flatAdjustmentRate'
});

// more to come
Adjustment.promotionReferences = [
    Adjustment.REFERENCE_FIRSTDIBS_PROMOTION_OFFER_DISCOUNT
];



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/Adjustment.js
// module id = 131
// module chunks = 64